import React, { useContext, useEffect, useState } from "react";
import { Form, Checkbox } from "antd";
import { respiratoryOptions } from "../../Options/clinicalImpressionOptions";
import DynamicInputFields from "../../../../blocks/FormItems/DynamicInputFields";

const Respiratory = ({ context, form }) => {
  const { formData } = useContext(context);
  const neurologicalData =
    formData?.clinical_diagnosis?.respiratory_diagnosis ||
    formData?.respiratory_diagnosis;
  const [showRespiratoryOthers, setShowRespiratoryOthers] = useState(
    neurologicalData?.includes("others")
  );

  const handleRespiratoryChange = (selectedOptions) => {
    setShowRespiratoryOthers(selectedOptions?.includes("others"));
  };

  useEffect(() => {
    setShowRespiratoryOthers(neurologicalData?.includes("others"));
  }, [formData]);

  return (
    <>
      <Form.Item name="respiratory_diagnosis" label="Respiratory Diagnosis">
        <Checkbox.Group
          options={respiratoryOptions}
          onChange={handleRespiratoryChange}
        />
      </Form.Item>
      {showRespiratoryOthers && (
        <DynamicInputFields
          field_key={"respiratory_others"}
          form={form}
          inputStyle={{ maxWidth: 800 }}
        />
      )}
    </>
  );
};

export default Respiratory;
